<template lang="pug">
  div(v-if="isActive")
    .block.block_wide
      .block__item.block__intro
        .block__intro-item.block__intro-item_md
          .grid.grid_v-margins
            .grid__col.grid__col_stretch
              h2 Лидеры прошлой недели
            .grid__col.grid__col_auto.d-none.d-sm-block
              router-link.button.button_secondary.button_sm(:to="{ name: 'ClubMembers', hash: '#clubTabs' }")
                span.button__text Смотреть весь рейтинг
      .block__item.block__item_sm.block__body
        .block__body-item(v-show="showFilters")
          .filters
            .filters__wrap
              .filters__container
                .filters__item.d-none.d-md-block
                  .filter
                    .filter__label Тип тренировки:
                    .filter__value
                      Select(
                        v-model="filters.discipline.val"
                        :value="filters.discipline.val"
                        :options="filters.discipline.options"
                        type="simple"
                        size="sm"
                        :searchable="false"
                        cls="multiselect_dropdown-auto"
                        @input="() => { filters.discipline.mobileVal = filters.discipline.val; updateItems() } "
                      )
                .filters__item.d-md-none
                  MobileFilter(
                    v-model="filters.discipline.mobileVal"
                    :text="getOptionName(filters.discipline.options, filters.discipline.val)"
                    :initialValue="filters.discipline.val"
                    name="Тип тренировки"
                    @change="val => { filters.discipline.val = val; updateItems() }"
                  )
                    template(slot="filter")
                      Radio(
                        v-for="option in filters.discipline.options"
                        :key="option.id"
                        class="w-100"
                        v-model="filters.discipline.mobileVal"
                        :value="option.id"
                        :label="option.name"
                      )
        .d-none.d-lg-block
          LeadersTable(:leaders="clubLeaders[discipline] || defaultLeaders")
        .d-lg-none
          LeadersTableMobile(:leaders="clubLeaders[discipline] || defaultLeaders")
      .block__item.d-sm-none
        router-link.button.button_secondary.button_sm.button_wide(:to="{ name: 'ClubMembers', hash: '#clubTabs' }")
          span.button__text Смотреть весь рейтинг
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { sportTypesMixin, disciplinesMixin } from '@/assets/js/mixins'
import Select from '@/components/Select'
import Radio from '@/components/Radio'
import MobileFilter from '@/components/MobileFilter'
import LeadersTable from './LeadersTable'
import LeadersTableMobile from './LeadersTableMobile'

export default {
  name: 'ClubLeaders',
  components: {
    Select,
    Radio,
    MobileFilter,
    LeadersTable,
    LeadersTableMobile
  },
  mixins: [sportTypesMixin, disciplinesMixin],
  props: {
    sportTypes: Array
  },
  data () {
    return {
      discipline: null,
      disciplines: {
        run: 'Бег',
        walk: 'Ходьба',
        cycling: 'Велозаезд',
        swimming: 'Плавание'
      },
      filters: {
        discipline: {
          val: null,
          mobileVal: null,
          options: []
        }
      },
      defaultLeaders: {
        byDistance: [],
        byTime: [],
        byHeight: []
      },
      showFilters: false,
      isActive: false
    }
  },
  computed: {
    ...mapState('club', [
      'clubLeaders',
      'membersUpdateTrigger'
    ]),
    clubDisciplines () {
      const result = []
      const codes = []

      for (let i = 0; i < this.sportTypes.length; i += 1) {
        const sport = this.sportTypes[i]

        if (this.sportTypesObj[sport] && this.sportTypesObj[sport].disciplines) {
          codes.push(...this.sportTypesObj[sport].disciplines)
        }
      }

      for (let j = 0; j < this.disciplinesArr.length; j += 1) {
        const discipline = this.disciplinesArr[j]
        if (codes.indexOf(discipline.code) !== -1) {
          result.push(discipline.code2)
        }
      }

      return result
    }
  },
  methods: {
    ...mapActions('club', [
      'getClubLeaders'
    ]),
    getOptionName (options, id) {
      if (!id) {
        return null
      }
      for (let i = 0; i < options.length; i += 1) {
        const option = options[i]
        if (option.id === id) {
          return option.name
        }
      }
      return null
    },
    getLeaders () {
      this.getClubLeaders({
        clubCode: this.$route.params.id || this.$getTenantIdClub()
      })
        .then(() => {
          this.getDisciplines()
        })
    },
    getDisciplines () {
      const filter = []
      const codes = []

      for (const key in this.clubLeaders) {
        const items = this.clubLeaders[key]
        if (items &&
          items.byDistance &&
          items.byDistance.length
        ) {
          filter.push({
            id: key,
            name: this.disciplines[key] || key
          })
          codes.push(key)
        }
      }

      const hasFilters = filter.length > 0
      const matches = []
      const f = []

      if (hasFilters) {
        for (let i = 0; i < this.clubDisciplines.length; i += 1) {
          const code = this.clubDisciplines[i]
          const index = codes.indexOf(code)
          if (index !== -1) {
            f.push(filter[index])
            matches.push(code)
          } else {
            f.push({
              id: code,
              name: this.disciplines[code] || code
            })
          }
        }

        if (matches.length) {
          const hasCurrentDiscipline = this.discipline && codes.indexOf(this.discipline) !== -1
          const val = hasCurrentDiscipline ? this.discipline : matches[0]
          this.filters.discipline.val = this.filters.discipline.mobileVal = val
        }

        this.filters.discipline.options = f
      }

      this.showFilters = this.clubDisciplines.length > 1
      this.isActive = hasFilters && matches.length > 0

      this.updateItems()
      this.$emit('loaded', this.isActive)
    },
    updateItems () {
      this.discipline = this.filters.discipline.val
    }
  },
  watch: {
    membersUpdateTrigger () {
      this.getLeaders()
    }
  },
  created () {
    this.getLeaders()
  }
}
</script>
